import logo from 'assets/images/logo-h-white.png';
import type { Step } from 'intro.js-react';

import OnboardingTooltipContent from './components/OnboardingTooltipContent';

const welcome: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    intro: (
      <OnboardingTooltipContent
        headerContent={<img className="w-100" src={logo} alt="" />}
        mainContent={
          <>
            <h3 className="text-center mb-3">Bienvenido</h3>
            <p className="w-100 text-center m-0">
              Haz click en <b>Siguiente</b> para empezar a tomar el control de tu energía.
            </p>
          </>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#side-bar',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <>
            <h3 className="text-center mb-3 text-uppercase">
              <b>Menú lateral</b>
            </h3>
            <p className="w-100 text-center m-0">
              Aquí encontrarás todos los <b>módulos</b> que forman parte de la plataforma.
            </p>
          </>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#user-profile-options',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="text-center mb-3 text-uppercase">
              <b>Mi perfil</b>
            </h3>
            <ul className="p-0 m-0 ml-3">
              <li>
                <span>
                  Aquí podrás encontrar tus <b>notificaciones más recientes</b>.
                </span>
              </li>
              <li>
                <span>
                  También, podrás acceder a <b>editar tus preferencias</b>, modo{' '}
                  <b>pantalla completa</b> y <b>cerrar sesión</b>.
                </span>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.onboarding-fab-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <>
            <h3 className="text-center mb-3 text-uppercase">
              <b>Centro de ayuda</b>
            </h3>
            <p className="w-100 text-center m-0">
              Siempre estará disponible la{' '}
              <b>información necesaria para refrescar tus conocimientos</b> cuando lo estimes
              conveniente.
            </p>
          </>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <>
            <h3 className="text-center mb-3 text-uppercase">
              <b>¡Felicidades!</b>
            </h3>
            <p className="w-100 text-center m-0">
              Has aprendido lo esencial para comenzar a navegar por la plataforma.
              <br />
              <br />
              <b>Haz clic en el botón de ayuda "?"</b> para aprender más acerca de cada módulo.
            </p>
          </>
        }
      />
    ),
  },
];

const charge_center_index: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100">
            <h3 className="text-center mb-3 text-uppercase">
              <b>CENTRO DE CARGA</b>
            </h3>
            <p className="w-100 text-center m-0">
              Aquí podrás ver y gestionar en tiempo real los cargadores pertenecientes a los activos
              asociados a tu perfil de usuario/a.
            </p>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.asset-gc-list',
    position: 'top',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En la sección <b>Monitor de Empalmes</b> encontrarás información resumida en tiempo real
            de lo que ocurre en cada empalme.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.gcm-power',
    position: 'left',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            El gráfico indica la <b>potencia demandada</b> por todos los cargadores del empalme.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.status-chart-container',
    position: 'left',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              El resumen de conectores indica <b>el estado en el que se encuentra cada conector</b>{' '}
              del empalme seleccionado.
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Ocupados</b>
              </li>
              <li>
                <b>Con falla</b>
              </li>
              <li>
                <b>Disponibles</b>
              </li>
              <li>
                <b>Fuera de línea</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.cc-views-buttons',
    position: 'left',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí, puedes acceder al <b>registro de transacciones</b> realizadas por un activo
            seleccionado.
            <br />
            <br />
            Además, tienes la opción para <b>ver todos los cargadores de todos los empalmes</b>{' '}
            asociados a tu cuenta de usuario/a.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.grid-connection-monitor-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            <b>Al hacer clic en un empalme</b> podrás acceder a toda la información en detalle de
            los estados de los cargadores y conectores en tiempo real.
          </p>
        }
      />
    ),
  },
];

const charge_center_details: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    element: '.tabs-content',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar un empalme encontrarás el{' '}
            <b>listado de cargadores y su estado en tiempo real</b>, con datos detallados del estado
            de cada conector.
            <br />
            <br />
            <b>Cuando un cargador no está conectado a la plataforma</b> algunas funcionalidades
            dejan de operar, como por ejemplo el "Cargar Hasta", esta funcionalidad se explicará más
            adelante.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charge-point-section-container',
    position: 'right',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              Los conectores pueden presentar diferentes estados en base a su conexión con nuestra
              plataforma, algunos de ellos pueden ser:
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Disponible</b>
              </li>
              <li>
                <b>Preparando</b>
              </li>
              <li>
                <b>Cargando</b>
              </li>
              <li>
                <b>Listo</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charge-point-section-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">Otros estados indican alertas y/o fallas:</p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Transacción suspendida por vehículo</b>
              </li>
              <li>
                <b>Falla de cargador</b>
              </li>
              <li>
                <b>Falla de conector</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charge-point-section-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            También, puedes ver los conectores que no están disponible en la plataforma.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charge-point-data',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar un cargador se desplegará toda la información resumida de este.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charge-center-drawer',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Acá encontraras la datos generales del cargador e información de las trasacciones que se
            han realizado en cada conector.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.advanced-options-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En opciones avanzadas puedes ejecutar un <b>Soft Reset</b> o un <b>Hard Reset</b> al
            cargador seleccionado.
            <br />
            <br />
            Las acciones que se podrían ejecutar al resetear un cargador{' '}
            <b>dependerán de acuerdo a cada fabricante</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.chargepoint-uptime-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al hacer clic en el botón <b>Uptime</b> podrás ver el tiempo que el cargador ha estado
            conectado a la red de internet.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            A continuación, se presenta un módulo que indica la conexión de cada cargador a la red,
            en general este calculo se conoce como <b>Uptime</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.dialog-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En esta ventana podrás ver información importante del cargador seleccionado, como su
            conexión a internet y tiempo en los diferentes estados: <b>cargando</b>,{' '}
            <b>disponible</b>, <b>con falla</b> y <b>fuera de línea</b>
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.uptime-modal-title',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En esta sección puedes distinguir el nombre y ubicación del cargador seleccionado
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.uptime-modal-daily-chart',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En este gráfico podrás ver el tiempo que el cargador ha estado conectado a la plataforma
            durante las <b>últimas 24 horas</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.uptime-modal-summary-chart',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En este apartado podrás ver el <b>porcentaje</b> y <b>tiempo</b> que el cargador ha
            estado disponible, cargando, con falla y fuera de línea.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.uptime-modal-period-select',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              Aquí puedes seleccionar el <b>periodo de tiempo</b> con el que se calculan los tiempos
              de cada estado en el gráfico de anillo. Las opciones disponibles son:
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Últimas 24 hrs</b>
              </li>
              <li>
                <b>Últimos 7 días</b>
              </li>
              <li>
                <b>Últimos 30 días</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.uptime-modal-total-chart',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Este indicador te muestra que porcentaje del tiempo el cargador ha estado conectado a la
            red.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.uptime-modal-donut-chart',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En este anillo puedes ver el <b>porcentaje</b> del tiempo en que el cargador estuvo en
            cada uno de sus estados. A la derecha puedes observar los minutos en que el cargador se
            mantuvo en un estado.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Ya has aprendido lo esencial para comenzar a ver el estado de tus cargadores.
          </p>
        }
      />
    ),
  },
];

const charge_center_details_connectors: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.tabs',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar vista <b>Por conector</b> se desplegará una tabla con todos los
            conectores disponibles.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.gc-detail-tabs',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            El objetivo de esa vista es <b>poder entregar información mas condensada</b> cuando el
            empalme cuenta con una cantidad alta de conectores.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.MuiDataGrid-root',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En esta tabla podras ver un resumen de los conectores.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charge-center-drawer',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar un <b>conector disponible</b>, desde la tabla, encontrarás el detalle del
            conector.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.connector-details-actions',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí puedes <b>seleccionar el % de carga o actualizar el SOC máximo</b> de carga que
            quieres realizar al vehículo eléctrico antes de iniciar la carga.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.connector-details-actions',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al utilizar esta funcionalidad, si se inicia una carga, ésta{' '}
            <b>terminará de forma automática al alcanzar el nivel de SoC</b> (State of Charge, o
            porcentaje de la batería) seleccionada.
            <br />
            <br />
            Esto es particularmente útil cuando se deben seguir patrones de carga para la extensión
            de la vida útil de la batería.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charge-center-drawer',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Cuando se selecciona un conector con estado <b>preparando</b>, <b>cargando</b> o{' '}
            <b>listo</b>, se mostrará adicionalmente el detalle del vehículo y los detalles de la
            transacción realizada.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL MÓDULO DE CENTRO DE CARGA!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const remote_management_index: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100">
            <h3 className="text-center mb-3">
              <b>GESTIÓN DE DEMANDA</b>
            </h3>
            <p className="w-100 text-center m-0">
              El objetivo del módulo es poder{' '}
              <b>gestionar y modular la potencia de los cargadores</b> para hacer un uso eficiente
              de ellos.
            </p>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.asset-gc-list',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí encontrarás el <b>resumen de cada empalme</b> en una lista separada por activos.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.line-chart',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            El grafico representa la <b>potencia máxima a la cual esta expuesta el empalme</b> si es
            que todos los cargadores cargan a la potencia asociada a cada uno de sus perfiles de
            carga.
            <br />
            <br />
            Si el grafico está vacío, es porque{' '}
            <b>no hay perfiles de carga asociados a los cargadores</b>, por lo tanto, estos cargarán
            a la máxima potencia según sus valores nominales de potencia.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.grid-connection-monitor-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            <b>Al hacer clic en un empalme</b> podrás acceder a toda la información en detalle de
            los perfiles de carga de los cargadores y conectores.
          </p>
        }
      />
    ),
  },
];

const remote_management_details: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    element: '.remote-management-detail-content',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            El perfil de carga del empalme corresponde a{' '}
            <b>la suma de todos los perfiles de carga de los cargadores</b> asociados a dicho
            empalme.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.profile-tabs-flex-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            <b>Para configurar un perfil de carga</b>, debes seleccionar un cargador, el cual
            desplegará los diferentes conectores disponibles.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.profile-tabs-flex-container button:nth-child(2)',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Si un cargador presenta un ícono de advertencia, significa que su{' '}
            <b>perfil de carga no ha sido sincronizado correctamente</b>, y por ende, no se aplicará
            según lo esperado.
            <br />
            <br />
            Para que los perfiles de carga estén sincronizados, éstos, deben ser aceptados por el
            cargador.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.profile-connector-selector-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w.100 text-center m-0">
            Al seleccionar un cargador, encontrarás una pestaña con todos los{' '}
            <b>conectores disponibles del cargador</b> seleccionado.
            <br />
            <br />
            Es posible establecer perfiles de carga a nivel de cargador a través del conector{' '}
            <b>"Input"</b>, o bien para cada uno de los conectores de manera independiente.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.charging-profile-chart-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            <b>Si existe un perfil de carga configurado</b> en Input o en algún conector
            seleccionado, se mostrará en el siguiente gráfico.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.editable-element-buttons',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Si un cargador no tiene un perfil creado, o deseas cambiar el perfil de carga asignado,
            haz clic en el botón <b>editar perfil</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.editable-element-content',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Puedes añadir puntos y moverlos en el gráfico{' '}
            <b>indicando la potencia máxima en un horario específico</b>.
            <br />
            <br />
            <b>La zona en color rojo</b> indica el horario en el que <b>NO</b> se recomienda
            realizar cargas de vehículos eléctricos por ser hora punta.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL MÓDULO GESTIÓN DE DEMANDA!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const fleet_map: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>FLOTA</b>
            </h3>
            <p className="w-100 m-0">
              El módulo tiene como objetivo entregar toda la información de aquellos vehículos{' '}
              <b>que cuentan con telemetría y están conectados a la plataforma</b>.
              <br />
              <br />
              Así, mejorando la información disponible para la operación de la flota eléctrica.
            </p>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.fleet-map-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al ingresar al módulo, encontrarás un mapa con la{' '}
            <b>ubicación de la flota en tiempo real</b>.
            <br />
            <br />
            Aquí, puedes buscar y visualizar la ubicación de un vehículo eléctrico en particular.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.fleet-map-legend-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En el recuadro <b>Leyenda</b> podrás encontrar el significado de los íconos mostrados en
            el mapa.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.fleet-map-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Cuando seleccionas un vehículo, se desplegará una ventana con los{' '}
            <b>detalles del vehículo</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.fleet-drawer',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás revisar el{' '}
            <b>estado de carga, autonomía, posición e historial del vehículo</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.fleet-drawer',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás revisar el <b>historial de transacciones</b> del vehículo seleccionado.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.trip-date-filter',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Debes <b>seleccionar un rango de fechas</b> para buscar el historial de registros de
            transacciones del vehículo seleccionado.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.trip-detail-list-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Se mostrarán <b>todos los viajes realizados</b> en las fechas seleccionadas.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.trip-detail-list-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar un registro, se desplegará un{' '}
            <b>resumen con los datos obtenidos del viaje realizado</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.fleet-map-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Además, podrás visualizar el trayecto del vehículo en el mapa.
          </p>
        }
      />
    ),
  },
];

const fleet_summary: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.tabs-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En la pestaña <b>Resumen</b> encontrarás una tabla con un listado donde podrás
            visualizar en tiempo real todos los vehículos eléctricos y sus datos.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL MÓDULO FLOTA!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const historical_chargepoint_uptime: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>UPTIME Y USO</b>
            </h3>
            <p className="w-100 m-0">
              Aquí podrás monitorear la actividad y detalle del uso de los cargadores y conectores
              en el tiempo.
            </p>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#historical-uptime-cp-filter',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás filtrar por <b>Activo</b> o <b>Grupo de cargadores</b> y además seleccionar
            el/los <b>cargadores</b> que desea analizar.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#historical-uptime-date-filter',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Escoge el <b>rango de timepo</b> en meses en que deseas ver el Uptime y Uso de tus
            cargadores y conectores.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#expandable-row-0',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              En el detalle de un cargador podrás encontrar <b>totalizados</b>:
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Uptime o porcentaje de tiempo en línea</b>
              </li>

              <li>
                <b>Tiempo fuera de línea</b>
              </li>

              <li>
                <b>Cantidad de transacciones</b>
              </li>

              <li>
                <b>Enegía cargada</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#expandable-row-0-expanded-row-0',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              En el detalle que se despliega por conector podrás encontrar:
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Cantidad de transacciones</b>
              </li>

              <li>
                <b>Energía cargada</b>
              </li>

              <li>
                <b>Tiempo disponible</b>
              </li>

              <li>
                <b>Tiempo cargando</b>
              </li>

              <li>
                <b>Tiempo en falla</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  // {
  //   tooltipClass: 'custom-introjs-tooltip',
  //   element: '#historical-uptime-download-btn',
  //   intro: (
  //     <OnboardingTooltipContent
  //       mainContent={
  //         <p className="w-100 text-center m-0">
  //           Al hacer clic en el botón <b>descargar detalle en excel</b> podrás descargar un informe
  //           con los datos seleccionados para que los puedas utilizar.
  //         </p>
  //       }
  //     />
  //   ),
  // },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <>
            <h3 className="text-center mb-3 text-uppercase">
              <b>¡HAS APRENDIDO EL SUBMÓDULO DE UPTIME Y USO DE CARGADORES</b>
            </h3>
            <p className="w-100 text-center m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </>
        }
      />
    ),
  },
];

const admin_index: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>ADMINISTRACIÓN</b>
            </h3>
            <p className="w-100 m-0">En el siguiente módulo podrás:</p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Administrar y crear usuarios.</b>
              </li>
              <li>
                <b>Acceder a información histórica sobre el estado de cargadores.</b>
              </li>
              <li>
                <b>Registro de transacciones y datos de la flota.</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#admin-users-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>ver, añadir usuarios y gestionar sus permisos</b> en la plataforma.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#admin-charge-points-status-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás acceder al <b>historial de errores</b> ocurridos en los diferentes
            cargadores a nivel de cada activo asociados a tu cuenta.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#admin-assets-transactions-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>consultar el detalle</b> de las transacciones de carga realizadas.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#admin-fleet-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>gestionar el estado de los vehículos</b> asociados a tu cuenta.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#admin-fleet-trip-history-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>consultar el historial de viajes</b> realizados por los vehículos
            asociados a tu cuenta.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    position: 'top',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Ingresa a alguno de estos submódulos para poder ver como funcionan en detalle.
          </p>
        }
      />
    ),
  },
];

const admin_users: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    element: '#admin-users-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>ver, añadir usuarios y gestionar sus permisos</b> en la plataforma.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.user-list-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En la tabla encontrarás un <b>listado de usuarios</b> asociados al activo administrado.
            <br />
            <br />
            Podrás buscar por usuario o email para conocer los detalles como RFID, Accesos y editar
            el usuario.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.add-user-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al hacer clic en el botón <b>AÑADIR USUARIO</b> se desplegará una ventana.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.edit-user-form-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              Aquí deberás <b>completar todos los datos solicitados</b> para añadir un usuario a la
              plataforma:
            </p>
            <br />
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Datos del usuario</b>
              </li>
              <li>
                <b>Asociar activos y flotas</b>
              </li>
              <li>
                <b>Autorizar carga remota</b>
              </li>
              <li>
                <b>Permitir acceso a la plataforma</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.asset-fleet-selection',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Los usuarios creados solo tendrán acceso a{' '}
            <b>los datos asociados a las flotas y activos seleccionados</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL SUBMÓDULO GESTIÓN DE USUARIOS!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const admin_chargepoint_status: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    element: '#admin-charge-points-status-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás acceder al <b>historial de errores</b> ocurridos en los diferentes
            cargadores a nivel de cada activo asociados a tu cuenta.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.error-logger-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar un activo, se desplegará una tabla con un{' '}
            <b>listado de de los errores</b> ordenados cronológicamente.
            <br />
            <br />
            En las columnas podrás encontrar detalles sobre{' '}
            <b>cuándo ocurrió el evento, en qué conector y que tipo de error fue</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#error-logger-header',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Podrás <b>filtrar el listado por fecha</b> o <b>buscar por conector o cargador</b>.
            <br />
            <br />
            Además podrás <b>enviar a tu email un informe</b> con los datos solicitados.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#error-logger-download-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al hacer clic en el botón <b>descargar</b> de la tabla podrás descargar un informe con
            todos datos filtrados y/o buscados.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.dynamic-download',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              Al descargar un informe, se desplegará una ventana con el <b>estado</b> de la
              descarga, los cuales pueden ser:
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Descargando</b>
              </li>

              <li>
                <b>Descargado</b>
              </li>

              <li>
                <b>Error de descarga</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL SUBMÓDULO DETALLE DE ERRORES!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const admin_transaction_history: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>consultar el detalle</b> de las transacciones de carga realizadas.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#transactions-logger-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            En la tabla se desplegará un <b>listado con las transacciones</b> ordenadas
            cronológicamente.
            <br />
            <br />
            En las columnas podrás encontrar todos los detalles sobre la transacción realizada.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.transactions-logger-date-filter',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Podrás <b>filtrar el listado por fecha</b> o <b>buscar por conector o cargador</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#transactions-logger-download-all',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al hacer clic en el botón <b>descargar</b> de la tabla podrás descargar un informe con
            todos datos filtrados y/o buscados.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#transactions-logger-download-one',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al hacer clic en el botón <b>descargar</b> podrás descargar un informe con los datos de
            la transacción seleccionada.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.dynamic-download',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              Al descargar un informe, se desplegará una ventana con el <b>estado</b> de la
              descarga, los cuales pueden ser:
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Descargando</b>
              </li>

              <li>
                <b>Descargado</b>
              </li>

              <li>
                <b>Error de descarga</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL SUBMÓDULO REGISTRO DE TRANSACCIONES!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const admin_fleet_management: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    element: '#admin-fleet-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>gestionar el estado de los vehículos</b> asociados a tu cuenta.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.fleet-table-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar un vehículo podrás <b>cambiar el estado</b> que indica si está{' '}
            <b>fuera de línea, en mantención</b> o <b>presenta fallas</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.state-change-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Luego de seleccionar un vehiculo se deshabilitará el botón "CAMBIAR ESTADO", y al hacer
            click en este se desplegara una ventana para cambiar el estado
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.edit-user-form-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Este estado sirve para <b>indicar</b> que el vehículo se encuentra con fallas y/o está
            en mantención.
            <br />
            <br />
            <b>No</b> es un estado propio del vehículo.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL SUBMÓDULO GESTIÓN DE FLOTA!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const admin_trip_history: Step[] = [
  {
    tooltipClass: 'custom-introjs-tooltip one-button',
    element: '#admin-fleet-trip-history-btn',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Aquí podrás <b>consultar el historial de viajes</b> realizados por los vehículos
            asociados a tu cuenta.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#trip-history-logger-container',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al seleccionar una flota, se desplegará una tabla con un listado con los viajes
            ordenados cronológicamente.
            <br />
            <br />
            En las columnas podrás encontrar todos los detalles sobre el <b>
              vehículo, ubicación
            </b>{' '}
            y <b>parámetros del viaje</b>.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#trip-history-logger-header',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Podrás <b>filtrar el listado por fecha</b> o <b>buscar por conector o cargador</b>.
            <br />
            <br />
            Además podrás <b>enviar a tu email un informe</b> con los datos solicitados.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '#trip-history-logger-download-button',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <p className="w-100 text-center m-0">
            Al hacer clic en el botón <b>descargar</b> de la tabla podrás descargar un informe con
            todos datos filtrados y/o buscados.
          </p>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    element: '.dynamic-download',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <p className="w-100 m-0">
              Al descargar un informe, se desplegará una ventana con el <b>estado</b> de la
              descarga, los cuales pueden ser:
            </p>
            <br />
            <ul className="p-0 m-0 ml-3">
              <li>
                <b>Descargando</b>
              </li>

              <li>
                <b>Descargado</b>
              </li>

              <li>
                <b>Error de descarga</b>
              </li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    tooltipClass: 'custom-introjs-tooltip',
    intro: (
      <OnboardingTooltipContent
        mainContent={
          <div className="w-100 text-center">
            <h3 className="mb-3">
              <b>¡HAS APRENDIDO EL SUBMÓDULO DETALLE DE VIAJES!</b>
            </h3>
            <p className="w-100 m-0">
              Si necesitas refrescar tus conocimiento puedes presionar el botón de ayuda.
            </p>
          </div>
        }
      />
    ),
  },
];

const OnboardingSteps: { [key: string]: Step[] } = {
  welcome,
  charge_center_index,
  charge_center_details,
  charge_center_details_connectors,
  remote_management_index,
  remote_management_details,
  fleet_map,
  fleet_summary,
  historical_chargepoint_uptime,
  admin_index,
  admin_users,
  admin_chargepoint_status,
  admin_transaction_history,
  admin_fleet_management,
  admin_trip_history,
};

export default OnboardingSteps;
